module.exports = __webpack_public_path__ + "img/mailing-mini.f99d2ee1.png";